/* KILO podcast: YouTube poster fallback for video IDs verified in Shopify.
   YouTube sometimes returns its 120x90 missing-maxres image with HTTP 200. */
(() => {
  'use strict';
  if (window.__kiloYouTubePostersReady) return;
  window.__kiloYouTubePostersReady = true;
  const stages = ['maxresdefault.jpg', 'sddefault.jpg', 'hqdefault.jpg', 'mqdefault.jpg'];
  const validId = /^[A-Za-z0-9_-]{11}$/;
  const check = img => {
    if (!(img instanceof HTMLImageElement)) return;
    const id = img.dataset.kiloYoutubePoster;
    if (!validId.test(id || '') || !img.complete) return;
    const stage = Math.max(0, Math.min(3, Number(img.dataset.kiloPosterStage) || 0));
    const minimumWidth = stage === 3 ? 280 : 400;
    if (img.naturalWidth >= minimumWidth) return;
    if (stage < stages.length - 1) {
      const next = stage + 1;
      img.dataset.kiloPosterStage = String(next);
      img.src = `https://i.ytimg.com/vi/${id}/${stages[next]}`;
      return;
    }
    // No usable thumbnail at any resolution. Keep the click-to-play control intact.
    if (img.dataset.kiloPosterStage === 'failed') return;
    img.dataset.kiloPosterStage = 'failed';
    img.hidden = true;
    img.style.display = 'none';
    const label = document.createElement('span');
    label.className = 'kilo-youtube-poster-fallback';
    label.textContent = 'Between 2 Racks';
    label.setAttribute('aria-hidden', 'true');
    img.after(label);
  };
  document.addEventListener('load', e => check(e.target), true);
  document.addEventListener('error', e => check(e.target), true);
  const scan = () => document.querySelectorAll('img[data-kilo-youtube-poster]').forEach(check);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true});
  else scan();
})();
